import axios from 'axios';

import { getData } from '@feature/utils';

import { TravelSettings, TravelSettingsRequest } from './TravelSettingsTypes';

export function get() {
  return axios.get<TravelSettings>('/travel/settings').then(getData);
}

export function update(request: TravelSettingsRequest) {
  return axios.put<TravelSettings>('/travel/settings', request).then(getData);
}
